import darpha from "../../assets/darpha_logo_digital.png";
import nfpa from "../../assets/nfpa-logo.png";
import cime from "../../assets/cime.png";
import nfsa from "../../assets/nfsa-logo.png";
import { fontFamily } from "./utils.js";

// Función auxiliar para obtener dimensiones proporcionales del logo Darpha
const getDarphaLogoDimensions = () => {
  // Estas dimensiones deben coincidir con las reales del archivo darpha_logo_digital.png
  // Si el logo es horizontal (más ancho que alto), usar ratio 2:1
  // Si el logo es vertical (más alto que ancho), usar ratio 1:2
  // Si el logo es cuadrado, usar ratio 1:1

  // Ajusta estos valores según las dimensiones reales de tu imagen
  const aspectRatio = 1.25; // Cambiar: 1.25 = ligeramente horizontal, 0.8 = ligeramente vertical, 1 = cuadrado

  return {
    aspectRatio,
    originalWidth: 500,
    originalHeight: 400, // 500/1.25 = 400 para ratio 1.25:1
  };
};

// Función para agregar solo la marca de agua central (llamar una vez por página)
export const addWatermark = (doc) => {
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  // Marca de agua Darpha Fire Solutions (más grande y más tenue)
  const centerX = pageWidth / 2;
  const centerY = pageHeight / 2;

  // Obtener dimensiones proporcionales del logo Darpha
  const logoDimensions = getDarphaLogoDimensions();
  const scaleFactor = 0.4; // Reducido para que no sea tan grande

  const logoWidth = pageWidth * scaleFactor;
  const logoHeight = logoWidth / logoDimensions.aspectRatio; // Mantiene proporción correcta

  doc.saveGraphicsState && doc.saveGraphicsState();
  doc.setGState && doc.setGState(new doc.GState({ opacity: 0.035 })); // Más tenue
  if (!doc.setGState) doc.setAlpha && doc.setAlpha(0.035);
  doc.addImage(
    darpha,
    "PNG",
    centerX - logoWidth / 2,
    centerY - logoHeight / 2,
    logoWidth,
    logoHeight,
  );
  doc.setGState && doc.setGState(new doc.GState({ opacity: 1 }));
  if (!doc.setGState) doc.setAlpha && doc.setAlpha(1);
  doc.restoreGraphicsState && doc.restoreGraphicsState();
};

// Función para agregar encabezado (sin marca de agua)
export const addHeader = (doc, y, tipoMantenimiento) => {
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  // Dibujar borde rojo
  doc.setDrawColor(204, 0, 0);
  doc.setLineWidth(1);
  doc.rect(5, 5, pageWidth - 10, pageHeight - 10);

  // Logo del header - mantener proporción correcta
  const logoDimensions = getDarphaLogoDimensions();
  const headerLogoWidth = 20; // Aumentado un poco para mejor visibilidad
  const headerLogoHeight = headerLogoWidth / logoDimensions.aspectRatio;
  doc.addImage(darpha, "PNG", 15, y, headerLogoWidth, headerLogoHeight);
  doc.addImage(
    nfpa,
    "center",
    doc.internal.pageSize.getWidth() - 25,
    y,
    12,
    12,
  );

  doc.setFontSize(14);
  doc.setTextColor(0, 0, 0);
  doc.setFont(fontFamily, "bold");
  doc.text(
    "DARPHA FIRE SOLUTIONS",
    doc.internal.pageSize.getWidth() / 2,
    y + 10,
    { align: "center" },
  );

  doc.setFont(fontFamily, "normal");
  doc.setFontSize(5);
  doc.setTextColor(204, 0, 0);
  doc.text(
    "- EMPRESA ESPECIALISTA EN SISTEMAS DE PROTECCIÓN DE INCENDIO -",
    doc.internal.pageSize.getWidth() / 2,
    y + 13,
    { align: "center" },
  );

  doc.setFont(fontFamily, "bold");
  doc.setFontSize(12);
  doc.setTextColor(0, 0, 0);
  doc.text(
    tipoMantenimiento,
    doc.internal.pageSize.getWidth() / 2 - 1,
    y + 20,
    {
      align: "center",
    },
  );
  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.2);
  doc.line(15, y + 23, pageWidth - 15, y + 23);
  doc.setFont(fontFamily, "normal");
};

// Función para agregar footer (sin marca de agua)
export const addFooter = (doc, y) => {
  const pageHeight = doc.internal.pageSize.getHeight();
  const pageWidth = doc.internal.pageSize.getWidth();

  // Solo agregar los logos del footer (sin marca de agua central)
  doc.addImage(cime, "center", 10, pageHeight - 20, 15, 15);
  doc.addImage(nfsa, "center", pageWidth - 30, pageHeight - 18, 20, 10);
};
